import { useEffect, useState, useContext } from 'react';
import ImageUndergraduate from '../../../../styles/images/undergraduate-visual.svg';
import SessionContext from '../../../../library/Core/SessionContext';
let SchoolLogo = sessionStorage.getItem('school-image') as any;

const UnderGraduateLayout = (props: any) => {
    const { sessionState } = useContext(SessionContext);
    const userStatusCode = sessionState?.userStatusCode;
    const userTypeCode = sessionState?.userTypeCode;
    const profileStatusCode = sessionState?.profileStatusCode; 
    const isInternalHeaderActive = userTypeCode != 'SUPER_ADMIN' && userTypeCode != 'INSTITUTE_ADMIN' && userStatusCode != 'ACTIVE' && profileStatusCode != 'basic-info-complete' && profileStatusCode != 'COMPLETE'

    //const [userStatusCode, setUserStatusCode] = useState(sessionStorage.getItem('user-status-code'));
    // useEffect(() => {
    //     setUserStatusCode(sessionStorage.getItem('user-status-code'));
    // }, []);
    return (
        <div className="main-wrap">
            <div className="leftPane">
                <div className="leftPaneWrap">
                    {isInternalHeaderActive && (
                        <div className="leftPaneHeaderWrap">
                            <div className="leftPaneHeader">
                                <img src={SchoolLogo} alt="" className="school_logo" />

                                <label className="user_name">
                                    Hey{' '}
                                    <span>{`${sessionState?.firstName} ${sessionState?.lastName}`}</span>
                                </label>
                            </div>
                        </div>
                    )}
                    <div className="leftPaneBodyWrap">
                        <div className="leftPaneBody">
                            <div className="qs_body aos-init aos-animate" data-aos="fade-right" data-nextpage="scholarship-details.html">
                                <div className="steps_questions">{props.children}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="rightPane basic-information undergraduate-college">
                <div className="rightPaneWrap">
                    {isInternalHeaderActive && (
                        <div className="rightPaneHeaderWrap">
                            <div className="rightPaneHeader">
                                <label className="user_name">
                                    Hey <span>{`${sessionState?.firstName} ${sessionState?.lastName}`}</span>
                                </label>
                            </div>
                        </div>
                    )}
                    <div className="rightPaneBodyWrap">
                        <div className="rightPaneBody aos-init aos-animate" data-aos="fade-left">
                            <div className="step step_1">
                                <a
                                    data-bs-toggle="collapse"
                                    data-bs-target="#listed_points"
                                    href=""
                                    className="mobile-step-block"
                                    aria-expanded="false"></a>
                                <div className="textDetail">
                                    <h2 className="stepHeader">Updating Your College Information Helps -</h2>
                                    <div className="listed_points" id="listed_points">
                                        <ul>
                                            <li>In Sharing College Experiences</li>
                                            <li>Your Profile To Become More Insightful</li>
                                            <li>Students to receive College Guidance</li>
                                        </ul>
                                    </div>
                                    <a href="" className="step_header_wrap_link">
                                        Read <span className="more">More</span>
                                        <span className="less">Less</span>
                                    </a>
                                </div>

                                <div className="step_img">
                                    <img src={ImageUndergraduate} className="img-fluid float_horizontal_animate" width="100%" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a data-bs-toggle="collapse" data-bs-target="#listed_points" href="" className="bg-drop" aria-expanded="false"></a>
        </div>
    );
};

export default UnderGraduateLayout;
